import moment from 'moment';

import { INotifications } from './../../../../types/responses/Notifications';

import { parseNotificationMessageType } from '../../../../utils/normalizers/notificationMessageType';

export const parseNotifications = (notifications: INotifications[]) => {
  return notifications?.map((not) => ({
    type: not.type,
    title: moment.utc(not.notificationTimestampDT).local().format('DD/MM/YYYY HH:mm'),
    message: parseNotificationMessageType(not.type),
  }));
};

export const getNotifications = (notificationsResponse, userSelected) => {
  const data = notificationsResponse.filter(({ userPk }) => userPk === userSelected?.user_pk)[0];
  return parseNotifications(data?.notifications?.notificationList);
};
